import { ModalConfirm } from 'mailup-web-components'
import PropTypes from 'prop-types'

import { useIntl } from 'react-intl'

const ModalInvalidFirstStep = ({ show, onCancel, onConfirm }) => {
  const intl = useIntl()

  return (
    <ModalConfirm
      show={show}
      title={intl.formatMessage({
        id: 'Load.AutomationWorkflow.ModalConfirmWaitFirstElementTitle'
      })}
      message={intl.formatMessage({
        id: 'Load.AutomationWorkflow.ModalConfirmWaitFirstElementContent'
      })}
      onClickConfirm={onConfirm}
      onClickCancel={onCancel}
      stringConfirm={intl.formatMessage({
        id: 'Load.MailupCommon.Yes'
      })}
      stringCancel={intl.formatMessage({ id: 'Load.MailupCommon.No' })}
    />
  )
}

ModalInvalidFirstStep.propTypes = {
  show: PropTypes.bool,
  onCancel: PropTypes.func,
  onConfirm: PropTypes.func
}

export default ModalInvalidFirstStep
